import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/app/store/store.ts';
import App from './App.tsx';
import { AppErrorBoundary } from '@/app/common/components/AppErrorBoundary.tsx';
import { reportError } from '@/app/common/utils/errorReporter.ts';
import '@/app/common/utils/openreplay';
import '@fontsource-variable/inter';
import './styles/global.scss';

window.addEventListener('unhandledrejection', (event) => {
  reportError(event.reason ?? 'Unhandled rejection');
});

window.addEventListener('error', (event) => {
  if (event.error instanceof Error) {
    reportError(event.error);
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </Provider>
  </StrictMode>,
);
